import React from 'react'

import Page from '../../../components/pdf/Page'

import Header from './_shared/Header'
import Content from './_shared/sections/Content'

const PdfDocument = ({ templateId }) => {
  return (
    <Page>
      <Header />
      <Content templateId={templateId} />
    </Page>
  )
}

export default PdfDocument
